import template from './window-view-type.jade';

export default angular.module('cian.addForm.windowViewType', []).directive('cianAfAboutObjectWindowViewType', () => ({
  scope: {},
  bindToController: {
    ad: '=',
    form: '=',
  },
  controller() {
    const getYardAndStreetValues = () => {
      if (this.ad.windowsViewType === 'yardAndStreet') {
        return [true, true];
      } else if (this.ad.windowsViewType === 'yard') {
        return [true, false];
      } else if (this.ad.windowsViewType === 'street') {
        return [false, true];
      }

      return [false, false];
    };

    [this.yard, this.street] = getYardAndStreetValues();

    this.updateAd = () => {
      this.ad.windowsViewType = (() => {
        if (this.yard && this.street) {
          return 'yardAndStreet';
        } else if (this.yard) {
          return 'yard';
        } else if (this.street) {
          return 'street';
        }

        return null;
      })();
    };
  },
  controllerAs: 'windowViewType',
  template,
})).name;
